/**
 * Fast Dash Calculations
 * 
 * ISWS Fast Dash uses same course and calculations as AKC FastCAT:
 * - Course is 100 yards
 * - MPH = 204.545 / time_seconds
 * - Points = MPH * handicap_multiplier
 * - Handicap based on height at withers:
 *   - >=18": 1.0x
 *   - 12-18": 1.5x
 *   - <12": 2.0x
 */

export const calculateMPH = (time: number): number => {
  if (time <= 0) return 0;
  // 100 yards / time * (3600 sec/hour / 1760 yards/mile) = 204.545 / time
  return 204.545 / time;
};

export const calculateHandicap = (height: number): number => {
  if (height > 18) return 1.0;
  if (height >= 12) return 1.5;
  return 2.0;
};

export const calculatePoints = (mph: number, handicap: number): number => {
  return mph * handicap;
};

export const formatToTwoDecimals = (value: number): string => {
  return value.toFixed(2);
};
